/**
 * @module common/config/url-config
 */

/**
 * @hideconstructor
 * @classdesc Конфигурация url-ов
 */
class UrlConfig {
  /**
   * @readonly
   * @description Ссылка на РосКвартал
   */
  static get baseRkUrl() {
    return process.env.MODE === 'production'
      ? 'https://roskvartal.ru'
      : 'http://localhost:54753';
  }

  /**
   * @readonly
   * @description Ссылка на РосКвартал lead-order
   */
   static get baseOrderUrl() {
    return process.env.MODE === 'production'
      ? 'https://order-api.roskvartal.ru'
      : 'http://localhost:5023';
  }

  /**
   * @readonly
   * @description Ссылка на лендинг
   */
  static get baseLandingUrl() {
    return process.env.MODE === 'production'
      ? 'https://marketing.roskvartal.ru/'
      : 'http://localhost:58498';
  }
}

export default UrlConfig;
